import { action } from 'satcheljs/lib/legacy';
import { ComposeViewState } from 'owa-mail-compose-store';

// This is to workaround a behavior in Edge/IE
// See VSO 15323 for more details
export default action('setIsFocusWorkaroundDivShown')(function setIsFocusWorkaroundDivShown(
    viewState: ComposeViewState,
    isShown: boolean
) {
    viewState.isFocusWorkaroundDivShown = isShown;
});
